import React, { FunctionComponent, useState } from 'react'

import { SyncLogsDialog } from '../components/SyncLogsDialog'

import { useApi } from './storeHook'
import { useBoolState } from './commonHooks'
import { useMessages } from './snackbarHooks'

import { integrationTypeByKey, IntegrationTypeKey } from '../types/integrationTypeUtils'

import { SyncLogModel } from '../server/mpsklad_core/Models/SyncLogModel'

export type SyncErrorHookData = {
  isLoading: boolean

  error: SyncLogModel | null

  onErrorClick: VoidFunction

  resetError: VoidFunction

  SyncErrorDialog: FunctionComponent
}

export const useSyncError =
  (integrationType: IntegrationTypeKey, errorId: string | undefined): SyncErrorHookData => {
    const api = useApi()

    const {showWarning} = useMessages()

    const [error, setError] = useState<SyncLogModel | null>(null)
    const [isLoading, setLoading, setLoaded] = useBoolState()

    const onErrorClick =
      async () => {
        if (!errorId) {
          showWarning('Ошибка устарела или не была записана')
          return
        }

        setLoading()

        try {
          setError(await api.userSync.syncLog(integrationTypeByKey[integrationType], errorId))
        } catch (e) {
          console.error(`Failed to load error #${errorId}`, e)
        } finally {
          setLoaded()
        }
      }

    const resetError = () => setError(null)

    return {
      isLoading, error, onErrorClick, resetError,
      SyncErrorDialog: () =>
        <SyncLogsDialog isLoading={isLoading} logs={error ? [error] : null} reset={resetError}/>
    }
  }